import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/images/user_avatar.jpg';

const _withScopeId = n => (_pushScopeId("data-v-df68ff08"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["href"];
const _hoisted_2 = {
  class: "resource"
};
const _hoisted_3 = {
  class: "resource-img"
};
const _hoisted_4 = ["src"];

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "file-type"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-icon_ppt"
})], -1));

const _hoisted_6 = {
  class: "bottom"
};
const _hoisted_7 = {
  class: "resource-name text-overflow",
  id: "courseName"
};
const _hoisted_8 = {
  class: "resource-num"
};
const _hoisted_9 = {
  class: "view-num"
};
const _hoisted_10 = {
  class: "unit"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "查看量", -1));

const _hoisted_12 = {
  class: "view-num"
};
const _hoisted_13 = {
  class: "unit"
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "转发量", -1));

const _hoisted_15 = {
  class: "view-num"
};
const _hoisted_16 = {
  class: "unit"
};

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "下载量", -1));

const _hoisted_18 = {
  class: "resource-mes"
};

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "teacher-info"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "photo-item"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})]), /*#__PURE__*/_createElementVNode("span", null, "朱成华")], -1));

const _hoisted_20 = {
  class: "upload-time"
};

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "上传时间 ", -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("a", {
    href: $props.resourceData.resourceUrl,
    target: "_blank",
    class: "resource-card"
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: $props.resourceData.coverUrl
  }, null, 8, _hoisted_4), _hoisted_5]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString($props.resourceData.name), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("p", _hoisted_10, _toDisplayString($props.resourceData.viewNum), 1), _hoisted_11]), _createElementVNode("div", _hoisted_12, [_createElementVNode("p", _hoisted_13, _toDisplayString($props.resourceData.sendNum), 1), _hoisted_14]), _createElementVNode("div", _hoisted_15, [_createElementVNode("p", _hoisted_16, _toDisplayString($props.resourceData.downNum), 1), _hoisted_17])]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("span", null, _toDisplayString($props.resourceData.uploadTime), 1)])])])])], 8, _hoisted_1);
}